// TLD rule: accept any alphabetic TLD of 2–12 characters. This covers all ccTLDs (2 chars)
// and common gTLDs (com, care, tech, agency, etc.) while still rejecting obvious nonsense.
// The optional path segment (/...) is kept permissive so users can paste a full browser URL —
// cleanDomain() normalises it to canonical form (host + optional lang segment) before the API call.
// The backend validates whether the domain actually exists.
export const DOMAIN_REGEX =
  /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,12}(\/[^\s]*)?$/;
export const HTTP_HTTPS_REGEX = /^https?:\/\//;
